import BaseSallaForm from './BaseSallaForm';

const SallaForm = () => (
	<BaseSallaForm
		showUsername
		showWarehouse
		copyBaseUrl
		advanceSettingsFields={['addHour', 'statuses']}
		developerSettingsFields={['token', 'apiUrl', 'productUrl']}
	/>
);

export default SallaForm;
